import { Alert, Button, Form, Input, Modal, Row } from "antd";
import { buttonStyle, fullWidthStyle, titleStyle } from "../../constants/style";
import { SubmitStatus } from "../../api/work-order-api";
import ApiContext from "../../api/context";
import { useContext, useState } from "react";
import Paragraph from "antd/es/typography/Paragraph";
import Title from "antd/es/typography/Title";
import { WorkOrder } from "../../api/models";

type WorkOrderRenameProps = {
  workOrder?: WorkOrder,
  onClose: () => void,
  onSave: (workOrder: WorkOrder) => void
};

export default function (p: WorkOrderRenameProps) {
  const [submitStatus, setSubmitStatus] = useState<SubmitStatus>(SubmitStatus.Idle);
  const [error, setError] = useState<string>();
  const [newName, setNewName] = useState<string>();
  const { api } = useContext(ApiContext);
  const isSubmitting = submitStatus === SubmitStatus.Submitting;
  const isNameValid = newName?.trim().length ?? 0 > 0;
  const canSubmit = !isSubmitting && isNameValid;

  return (
    <>
      <Title style={titleStyle} level={4}>Rename Work Order</Title>
      <Form
        layout="vertical"
        colon={false}>
        <Form.Item label="Work Order Name">
          <Input
            placeholder={p.workOrder?.name}
            value={newName}
            onChange={e => setNewName(e.target.value)}
          />
        </Form.Item>
        <Row style={fullWidthStyle} justify="end" align="middle">
          <Button
            type="default"
            style={buttonStyle}
            onClick={p.onClose}>
            Close
          </Button>
          <Button
            type="primary"
            style={buttonStyle}
            disabled={!canSubmit}
            loading={isSubmitting}
            onClick={() => {
              setSubmitStatus(SubmitStatus.Submitting);
              api?.putWorkOrder({
                ...p.workOrder!,
                name: newName ?? p.workOrder!.name
              }).then(response => {
                if (!response.good() || !response.body) {
                  throw "Bad response received.";
                }

                p.onSave(response.body);
              }).catch(err => {
                setError("Failed to rename the template.");
                setSubmitStatus(SubmitStatus.Idle);
              });
            }}>
            Rename
          </Button>
        </Row>
        {
          !error ? undefined :
            <>
              <Paragraph></Paragraph>
              <Alert style={fullWidthStyle} type="error" title={error} />
            </>
        }
      </Form>
    </>);
}

